import getBlobDuration from "get-blob-duration";

export const getBlobURL = (blob, file) => {
  let url = null;
  try {
    if (blob && blob.size > 0) {
      const objectToUse = file || blob;
      console.log("This is object to use",objectToUse);
      url = URL.createObjectURL(objectToUse);
      console.log("This is the url",url);
    }
  } catch (err) {
    console.error("Error creating blob URL:", err);
  }
  return url;
};

export const getFile = (blob, buffer, fileName) => {
  console.log("The blob buffer and the filename",blob,"Buffer : ",buffer ,"Filename",fileName);
  let file = null;
  try {
    // file = new File([blob], "noname.mp3", { type: blob.type });
    const audioBlob = new Blob([blob], { type: "audio/mp3" });
    console.log("this is blob",blob)
    console.log("THis is the audio bolb",audioBlob);

    file = new File([audioBlob], fileName, {
      type: "audio/mp3",
      lastModified: Date.now(),
    });
    console.log("This is the file",file);
  } catch (err) {
    file = new File([buffer], fileName, {
      type: "audio/mp3",
      lastModified: Date.now(),
    });
    console.log("This is the file created by buffer",file);
  }
  return file;
};

export const getDuration = async (blob) => {
  let duration = 0;
  duration = await getBlobDuration(blob)
    .then((d) => {
      return d;
    })
    .catch(async (e) => {
      console.log(e);
      return 0;
    });
  return duration;
};
